import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"type":"number","label":_vm.$t('Maximum applicable times'),"outlined":"","hide-details":"auto"},model:{value:(_vm.maximum_applicable_times),callback:function ($$v) {_vm.maximum_applicable_times=$$v},expression:"maximum_applicable_times"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }